/** A failed session check is distinct from a confirmed anonymous response. */
export function sessionGate(state: { hasSession: boolean; loading: boolean; restoreFailed: boolean }): 'ready' | 'checking' | 'unavailable' | 'anonymous' {
  if (state.hasSession) return 'ready';
  if (state.loading) return 'checking';
  if (state.restoreFailed) return 'unavailable';
  return 'anonymous';
}
